import cx from "classnames";
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";

import { useResourceStrings } from "../../localization/hooks";
import * as styles from "./LoginButton.module.css";

type LoginButtonProps = Readonly<{
  onSignIn: () => void;
}>;

export const LoginButton = ({ onSignIn }: LoginButtonProps) => {
  const [signInToAccountAriaLabel, signInLinkText] = useResourceStrings(
    "signInToAccountAriaLabel",
    "signInLinkText"
  );

  return (
    <div className={styles.cMe}>
      <a
        onClick={onSignIn}
        aria-label={signInToAccountAriaLabel}
        target="_top"
        href="#"
        className={styles.mectrlTrigger}
      >
        <span className={styles.mectrlScreenReaderText}>{signInToAccountAriaLabel}</span>
        <div className={styles.mectrlTopHeader} aria-hidden={"true"} role="presentation">
          <div className={cx(styles.mectrlHeaderText, styles.mectrlSignInLink)}>
            {signInLinkText}
          </div>
          <div
            className={cx(styles.mectrlProfilepic, styles.mectrlSignInCircleGlyph)}
            aria-hidden={"true"}
            role="presentation"
          ></div>
        </div>
      </a>
    </div>
  );
};
